import {Subscriber} from 'rxjs';
import {Component, Directive, HostListener} from '@angular/core';
import {DialogPopComponent} from "../dialog-pop/dialog-pop.component";
import {MatDialog} from "@angular/material/dialog";
import {Lib} from "../../../libs/Lib";
import {isGalaxy, isHostLocal} from "../../common";

// import {
//     Subscriber,
//     Subject,
//     Observable
// } from "rxjs";
// type UnSubscriber = Function | Subscriber<any>;
// var c:UnSubscriber = Observable.create((a)=>{}).subscribe(()=>{});


@Directive()
// tslint:disable-next-line:directive-class-suffix
export class Compbaser {
    private unsubFunctions: Array<any> = [];
    private noRedirect = false;
    me = '';

    @HostListener('click', ['$event'])
    clickHandler(event) {
        if (this.noRedirect) {
            event.stopImmediatePropagation();
            event.preventDefault();
        }
    }

    constructor(protected dialog?: MatDialog, m_me?: string) {
        this.me = '';
    }

    public setMe(i_value: string) {
        if (isGalaxy()) return;
        this.me = i_value;
    }

    public preventRedirect(i_value: boolean) {
        this.noRedirect = i_value;
    }

    protected getCompSelector(i_constructor) {
        if (!isHostLocal()) {
            return;
        }
        const annotations = Reflect['getMetadata']('annotations', i_constructor);
        if (!annotations)
            return '';
        const componentMetadata = annotations.find(annotation => {
            return (annotation instanceof Component);
        });
        return componentMetadata.selector;
    }

    // tslint:disable-next-line:variable-name
    protected cod(i_function: any): void {
        if (!this.unsubFunctions) return Lib.DevShow('warning did not push unsub, prob too fast destroyed');
        this.unsubFunctions.push(i_function);
    }

    openDialog(message: string, options: {}, callBack?: (v) => void): void {
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '333px',
            width: '400px',
            data: {
                name: message,
                options
            }
        });
        this.cod(
            dialogRef.afterClosed().subscribe(result => {
                // console.log('The dialog was closed ' + result);
                if (callBack) callBack(result);
            })
        );
    }

    // tslint:disable-next-line:use-lifecycle-interface
    ngOnDestroy() {
        // console.log('unsubscribing on behalf of ' + this.me);
        this.unsubFunctions.map((f: any) => {
            if (f instanceof Subscriber) {
                f.unsubscribe();
            } else {
                f();
            }
        });
        this.destroy();
        this.unsubFunctions = null;
        this.me = null;
    }

    // override by subclass component
    destroy() {
    }
}
